import script from "./AlertTag.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertTag.vue?vue&type=script&setup=true&lang=js"

import "./AlertTag.vue?vue&type=style&index=0&id=0ce71852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce71852"]])

export default __exports__